/* eslint-disable space-before-function-paren */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import './assets/css/base.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'
import $ from 'jquery'
import axios from 'axios'

Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(VueCookies)
Vue.config.productionTip = false

var i18n = null;
function getChinese() {
  return axios.get('../static/lang/zh.json') // 请求1
}

function getEnglish() {
  return axios.get('../static/lang/en.json') // 请求2
}
function getKoren() {
  return axios.get('../static/lang/kr.json') // 请求2
}
axios.all([getChinese(), getEnglish(), getKoren()]) // 两个请求放到数组中传递给all()
  .then(axios.spread(function (zh, en, kr) { // 多个请求都发送完毕，拿到返回的数据
    // 两个请求现在都执行完成
    i18n = new VueI18n({
      locale: 'zh', // 语言标识
      messages: {
        'zh': zh.data,
        'en': en.data,
        'kr': kr.data
      }
    })
    // eslint-disable-next-line no-new
    new Vue({
      el: '#app',
      i18n,
      router,
      components: { App },
      template: '<App/>'
    })
  }))



// WEBPACK FOOTER //
// ./src/main.js